import { useState, useEffect, ReactNode } from "react";
import { LoadingOverlay } from "./LoadingOverlay";
import { loadingService, type LoaderType } from "./loading.service";
import { LoadingContext } from "./LoadingContext";

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loaderType, setLoaderType] = useState<LoaderType>("central");
  const [inlineLoadingElement, setInlineLoadingElement] = useState<string | null>(null);

  useEffect(() => {
    // Subscribe to global loading service
    const unsubscribe = loadingService.subscribe((loading, type) => {
      console.log("LoadingProvider: isLoading changed to", loading, "type:", type);
      setIsLoading(loading);
      setLoaderType(type || "central");
    });

    // Subscribe to inline loading service
    const unsubscribeInline = loadingService.subscribeInline((elementId, loading) => {
      console.log(
        "LoadingProvider: inline loading changed, elementId:",
        elementId,
        "loading:",
        loading
      );
      setInlineLoadingElement(elementId);
    });

    return () => {
      unsubscribe();
      unsubscribeInline();
    };
  }, []);

  const setLoading = (loading: boolean, type: LoaderType = "central", elementId?: string) => {
    if (loading) {
      loadingService.show(type, elementId);
    } else {
      loadingService.hide();
    }
  };

  return (
    <LoadingContext.Provider value={{ isLoading, loaderType, inlineLoadingElement, setLoading }}>
      {children}
      <LoadingOverlay isVisible={isLoading && loaderType === "central"} />
    </LoadingContext.Provider>
  );
};
